import { Grid, withStyles } from '@material-ui/core';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { array, number, object, string } from 'yup';
import Button from 'shared/newComponents/Button/Button';
import TextField from 'shared/newComponents/TextField';
import { RecruiterV2Service } from 'shared/services';
import CustomDialog from '../../../../../../../../../../components/CustomDialog';
import { styles } from './PositionsLevelForm.styles';

function PositionsLevelForm({
  recruiterData,
  isOpen,
  onClose,
  recruiterEdited,
  classes,
  t,
}) {
  const [experiencePositionSelectCard, setExperiencePositionSelectCard] =
    useState([]);

  const defaultExperiencePositionCard = {
    position: '',
    experienceLevel: '',
  };

  const MODEL = {
    userPositionExperiences: 'userPositionExperiences',
  };

  useEffect(() => {
    if (
      recruiterData.userPositionExperiences &&
      recruiterData.userPositionExperiences.length !== 0
    ) {
      onAddExperiencePositionExist(recruiterData.userPositionExperiences);
    } else {
      onAddExperiencePosition();
    }
  }, [recruiterData]);

  const onAddExperiencePositionExist = userExperienceIndustryCategory => {
    setExperiencePositionSelectCard(userExperienceIndustryCategory);
  };

  const onAddExperiencePosition = () => {
    setExperiencePositionSelectCard([
      ...experiencePositionSelectCard,
      defaultExperiencePositionCard,
    ]);
    formik.setFieldValue(MODEL.userPositionExperiences, [
      ...formik.values[MODEL.userPositionExperiences],
      defaultExperiencePositionCard,
    ]);
  };

  const onRemove = indexToRemove => {
    const filterDepartmentTable = experiencePositionSelectCard.filter(
      (item, index) => index !== indexToRemove
    );
    const filterDepartmentTableFromFormik = formik.values[
      MODEL.userPositionExperiences
    ].filter((item, index) => index !== indexToRemove);

    setExperiencePositionSelectCard(filterDepartmentTable);
    formik.setFieldValue(
      `${MODEL.userPositionExperiences}`,
      filterDepartmentTableFromFormik
    );
  };

  const isLastIndex = index => {
    return experiencePositionSelectCard.length === index + 1;
  };

  const formData = {
    userPositionExperiences: recruiterData
      ? recruiterData.userPositionExperiences
      : null,
  };

  const validationSchema = Yup.object().shape({
    userPositionExperiences: array().of(
      object().shape({
        experienceLevel: number()
          .positive()
          .min(1, `${t`recruiter:reqVal`} 0`)
          .required(t('projectCreator:core.requiredField')),
        position: string()
          .strict(false)
          .trim()
          .required(t('projectCreator:core.requiredField')),
      })
    ),
  });

  const formik = useFormik({
    initialValues: formData,
    validationSchema: validationSchema,
    onSubmit: values => {
      const body = {
        userPositionExperiences: values.userPositionExperiences,
      };

      RecruiterV2Service.editRecruiterV2(recruiterData.id, body, {
        stage: 'position_experiences_data',
      })
        .then(() => {
          recruiterEdited();
          onClose();
        })
        .catch(error => {
          console.log(error);
          alert(t`recruiter:saveError`);
        });
    },
  });

  return (
    <CustomDialog
      maxWidth={'md'}
      title={t`recruiter:positionsLvl`}
      isOpen={isOpen}
      onCloseDialog={onClose}
      body={
        <Grid container>
          <FormikProvider value={formik}>
            <FieldArray
              name={MODEL.userPositionExperiences}
              render={() => {
                return experiencePositionSelectCard.map((item, index) => {
                  return (
                    <Grid container key={index}>
                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          label={t`recruiter:position`}
                          name={`${MODEL.userPositionExperiences}[${index}].position`}
                          formik={formik}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <TextField
                          type={'number'}
                          label={t('candidateCreator:step2.experienceLevel')}
                          name={`${MODEL.userPositionExperiences}[${index}].experienceLevel`}
                          formik={formik}
                        />
                      </Grid>

                      <Grid
                        container
                        className={classes.wrapLastIndex}
                        spacing={2}
                        alignItems="center"
                      >
                        {isLastIndex(index) ? (
                          <Grid item xs={12} sm={12} md={12}>
                            {index !== 0 ? (
                              <Grid item xs={12} sm={12} md={12}>
                                <Button
                                  className={classes.wrapLastIndexBtn}
                                  fontColor={'red'}
                                  label={t(
                                    'candidateCreator:step2.removeExperience'
                                  )}
                                  onClick={() => onRemove(index)}
                                />
                              </Grid>
                            ) : null}
                            <Grid item xs={12} sm={12} md={12}>
                              <Button
                                label={t(
                                  'candidateCreator:step2.addExperience'
                                )}
                                onClick={onAddExperiencePosition}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={12} md={12}>
                            <Button
                              className={classes.wrapRemoveBtn}
                              fontColor={'red'}
                              label={t(
                                'candidateCreator:step2.removeExperience'
                              )}
                              onClick={() => onRemove(index)}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  );
                });
              }}
            />
            <Grid
              container
              justifyContent="center"
              onClick={formik.handleSubmit}
            >
              <Grid item xs={12} sm={12} md={12}>
                <Button label={t`recruiter:save`} type="submit" />
              </Grid>
            </Grid>
          </FormikProvider>
        </Grid>
      }
    />
  );
}

export default connect()(
  withStyles(styles)(withTranslation()(PositionsLevelForm))
);
